module.exports = __webpack_public_path__ + "static/media/twinkle-fall.00b999aa.mp3";